import script from "./system-distribution-chart.vue?vue&type=script&lang=ts&setup=true"
export * from "./system-distribution-chart.vue?vue&type=script&lang=ts&setup=true"

import "./system-distribution-chart.vue?vue&type=style&index=0&id=40b974e6&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40b974e6"]])

export default __exports__